module.exports = __webpack_public_path__ + "img/rexam.207b7717.svg";